import { showErrorToast } from "@src/appV2/lib/Notifications";
// eslint-disable-next-line no-restricted-imports -- Bridge to old app code
import {
  sendEmployeeLoginLink,
  sendFacilityLoginLink,
} from "@src/containers/enter/commonLogin/api";
// eslint-disable-next-line no-restricted-imports -- Bridge to old app code
import { getErrorMessage } from "@src/utils/errors";
// eslint-disable-next-line no-restricted-imports -- Bridge to old app code
import { getSignInLink } from "@src/utils/user";

interface SendLoginEmailParams {
  email: string;
  keepMeLogin: boolean;
  requestedURL: string | undefined;
}

/**
 * Sends login email - abstracted from old app code
 * This keeps the mobile component clean and isolated
 */
export async function sendLoginEmail({
  email,
  keepMeLogin,
  requestedURL,
}: SendLoginEmailParams): Promise<boolean> {
  try {
    // Store email in localStorage for verification flow
    localStorage.setItem("emailToVerify", email);

    // Generate sign-in link with redirect URL
    const signInLink = getSignInLink(requestedURL ?? "", email, keepMeLogin);

    // Send login link via appropriate endpoint based on email domain
    await (email.includes("clipboardhealth.com")
      ? sendEmployeeLoginLink(email, signInLink)
      : sendFacilityLoginLink(email, signInLink));

    return true;
  } catch (error: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- getErrorMessage expects any
    const message = String(getErrorMessage(error as any));
    showErrorToast(message);
    return false;
  }
}
